// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file web/public/onboarding.proto (package web.public, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { Error } from "./error_pb.js";

/**
 * Helps guide the onboarding flow with a list of steps
 *
 * @generated from message web.public.OnboardingStatus
 */
export class OnboardingStatus extends Message<OnboardingStatus> {
  /**
   * @generated from field: repeated web.public.OnboardingStatus.Step steps = 1;
   */
  steps: OnboardingStatus.Step[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 2;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: web.public.OnboardingStatus.CompletionStatus completion_status = 3;
   */
  completionStatus = OnboardingStatus.CompletionStatus.UNKNOWN;

  /**
   * @generated from field: float detailed_step_progress = 4;
   */
  detailedStepProgress = 0;

  /**
   * @generated from field: string detailed_step_message = 5;
   */
  detailedStepMessage = "";

  /**
   * @generated from field: web.public.OnboardingStatus.SignupType signup_type = 6;
   */
  signupType = OnboardingStatus.SignupType.CREDIT;

  /**
   * @generated from field: web.public.OnboardingStatus.DuplicateAccountDetails duplicate_account_details = 7;
   */
  duplicateAccountDetails?: OnboardingStatus.DuplicateAccountDetails;

  /**
   * @generated from field: web.public.OnboardingStatus.InstatouchInfo instatouch_info = 8;
   */
  instatouchInfo?: OnboardingStatus.InstatouchInfo;

  constructor(data?: PartialMessage<OnboardingStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.OnboardingStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "steps", kind: "message", T: OnboardingStatus.Step, repeated: true },
    { no: 2, name: "completed_at", kind: "message", T: Timestamp },
    { no: 3, name: "completion_status", kind: "enum", T: proto3.getEnumType(OnboardingStatus.CompletionStatus) },
    { no: 4, name: "detailed_step_progress", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "detailed_step_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "signup_type", kind: "enum", T: proto3.getEnumType(OnboardingStatus.SignupType) },
    { no: 7, name: "duplicate_account_details", kind: "message", T: OnboardingStatus.DuplicateAccountDetails },
    { no: 8, name: "instatouch_info", kind: "message", T: OnboardingStatus.InstatouchInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OnboardingStatus {
    return new OnboardingStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OnboardingStatus {
    return new OnboardingStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OnboardingStatus {
    return new OnboardingStatus().fromJsonString(jsonString, options);
  }

  static equals(a: OnboardingStatus | PlainMessage<OnboardingStatus> | undefined, b: OnboardingStatus | PlainMessage<OnboardingStatus> | undefined): boolean {
    return proto3.util.equals(OnboardingStatus, a, b);
  }

  static _enums: {
    CompletionStatus: typeof OnboardingStatus.CompletionStatus,
    SignupType: typeof OnboardingStatus.SignupType,
  };
}

export namespace OnboardingStatus {
  /**
   * @generated from enum web.public.OnboardingStatus.CompletionStatus
   */
  export enum CompletionStatus {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: WAITLIST_UNDERAGE = 1;
     */
    WAITLIST_UNDERAGE = 1,

    /**
     * @generated from enum value: WAITLIST_STATE = 2;
     */
    WAITLIST_STATE = 2,

    /**
     * Between onboarding and post onboarding/ risk flagged
     *
     * @generated from enum value: RISK_CHECKING = 3;
     */
    RISK_CHECKING = 3,

    /**
     * Manual review required
     *
     * @generated from enum value: RISK_FLAGGED = 4;
     */
    RISK_FLAGGED = 4,

    /**
     * Deprecated for PROGRAM_FETCHING
     *
     * @generated from enum value: RISK_PASSED = 5;
     */
    RISK_PASSED = 5,

    /**
     * @generated from enum value: RISK_RETRY = 6;
     */
    RISK_RETRY = 6,

    /**
     * @generated from enum value: PROGRAMS_FETCHING = 7;
     */
    PROGRAMS_FETCHING = 7,

    /**
     * @generated from enum value: PROGRAMS_FETCHED = 8;
     */
    PROGRAMS_FETCHED = 8,

    /**
     * @generated from enum value: DUPLICATE_ACCOUNT = 10;
     */
    DUPLICATE_ACCOUNT = 10,

    /**
     * @generated from enum value: ADDRESS_ISSUE = 11;
     */
    ADDRESS_ISSUE = 11,

    /**
     * @generated from enum value: FROZEN_FILE = 12;
     */
    FROZEN_FILE = 12,

    /**
     * @generated from enum value: ELIGIBLE_FOR_MANUAL_UPLOAD = 13;
     */
    ELIGIBLE_FOR_MANUAL_UPLOAD = 13,

    /**
     * @generated from enum value: ITIN_SUBMITTED = 15;
     */
    ITIN_SUBMITTED = 15,
  }
  // Retrieve enum metadata with: proto3.getEnumType(OnboardingStatus.CompletionStatus)
  proto3.util.setEnumType(OnboardingStatus.CompletionStatus, "web.public.OnboardingStatus.CompletionStatus", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "WAITLIST_UNDERAGE" },
    { no: 2, name: "WAITLIST_STATE" },
    { no: 3, name: "RISK_CHECKING" },
    { no: 4, name: "RISK_FLAGGED" },
    { no: 5, name: "RISK_PASSED" },
    { no: 6, name: "RISK_RETRY" },
    { no: 7, name: "PROGRAMS_FETCHING" },
    { no: 8, name: "PROGRAMS_FETCHED" },
    { no: 10, name: "DUPLICATE_ACCOUNT" },
    { no: 11, name: "ADDRESS_ISSUE" },
    { no: 12, name: "FROZEN_FILE" },
    { no: 13, name: "ELIGIBLE_FOR_MANUAL_UPLOAD" },
    { no: 15, name: "ITIN_SUBMITTED" },
  ]);
}

export namespace OnboardingStatus {
  /**
   * Which type of account the user is onboarding for
   *
   * @generated from enum web.public.OnboardingStatus.SignupType
   */
  export enum SignupType {
    /**
     * @generated from enum value: CREDIT = 0;
     */
    CREDIT = 0,

    /**
     * @generated from enum value: CASH_CARD = 1;
     */
    CASH_CARD = 1,

    /**
     * @generated from enum value: FREEMIUM = 2;
     */
    FREEMIUM = 2,

    /**
     * @generated from enum value: CASH_ADVANCE = 3;
     */
    CASH_ADVANCE = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(OnboardingStatus.SignupType)
  proto3.util.setEnumType(OnboardingStatus.SignupType, "web.public.OnboardingStatus.SignupType", [
    { no: 0, name: "CREDIT" },
    { no: 1, name: "CASH_CARD" },
    { no: 2, name: "FREEMIUM" },
    { no: 3, name: "CASH_ADVANCE" },
  ]);
}

export namespace OnboardingStatus {
  /**
   * @generated from message web.public.OnboardingStatus.Step
   */
  export class Step extends Message<OnboardingStatus.Step> {
    /**
     * @generated from field: string name = 1;
     */
    name = "";

    /**
     * @generated from field: uint32 ordinality = 2;
     */
    ordinality = 0;

    /**
     * @generated from field: bool complete = 3;
     */
    complete = false;

    /**
     * @generated from oneof web.public.OnboardingStatus.Step.value
     */
    value: {
      /**
       * Ruby proto library doesnt work properly.
       * Basically just dumps all these fields into the containing class
       *
       * @generated from field: web.public.UpdateNameRequest update_name_request = 4;
       */
      value: UpdateNameRequest;
      case: "updateNameRequest";
    } | {
      /**
       * @generated from field: web.public.UpdatePhoneRequest update_phone_request = 5;
       */
      value: UpdatePhoneRequest;
      case: "updatePhoneRequest";
    } | {
      /**
       * @generated from field: web.public.UpdateAddressRequest update_address_request = 6;
       */
      value: UpdateAddressRequest;
      case: "updateAddressRequest";
    } | {
      /**
       * @generated from field: web.public.UpdateDOBRequest update_dob_request = 7;
       */
      value: UpdateDOBRequest;
      case: "updateDobRequest";
    } | {
      /**
       * @generated from field: web.public.UpdateSSNRequest update_ssn_request = 8;
       */
      value: UpdateSSNRequest;
      case: "updateSsnRequest";
    } | { case: undefined; value?: undefined } = { case: undefined };

    constructor(data?: PartialMessage<OnboardingStatus.Step>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.OnboardingStatus.Step";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "ordinality", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 3, name: "complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
      { no: 4, name: "update_name_request", kind: "message", T: UpdateNameRequest, oneof: "value" },
      { no: 5, name: "update_phone_request", kind: "message", T: UpdatePhoneRequest, oneof: "value" },
      { no: 6, name: "update_address_request", kind: "message", T: UpdateAddressRequest, oneof: "value" },
      { no: 7, name: "update_dob_request", kind: "message", T: UpdateDOBRequest, oneof: "value" },
      { no: 8, name: "update_ssn_request", kind: "message", T: UpdateSSNRequest, oneof: "value" },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OnboardingStatus.Step {
      return new OnboardingStatus.Step().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OnboardingStatus.Step {
      return new OnboardingStatus.Step().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OnboardingStatus.Step {
      return new OnboardingStatus.Step().fromJsonString(jsonString, options);
    }

    static equals(a: OnboardingStatus.Step | PlainMessage<OnboardingStatus.Step> | undefined, b: OnboardingStatus.Step | PlainMessage<OnboardingStatus.Step> | undefined): boolean {
      return proto3.util.equals(OnboardingStatus.Step, a, b);
    }

    static _enums: {
    };
  }
}

export namespace OnboardingStatus {
  /**
   * @generated from message web.public.OnboardingStatus.DuplicateAccountDetails
   */
  export class DuplicateAccountDetails extends Message<OnboardingStatus.DuplicateAccountDetails> {
    /**
     * @generated from field: web.public.OnboardingStatus.DuplicateAccountDetails.Status status = 1;
     */
    status = OnboardingStatus.DuplicateAccountDetails.Status.NO_MATCH;

    /**
     * @generated from field: string email = 2;
     */
    email = "";

    constructor(data?: PartialMessage<OnboardingStatus.DuplicateAccountDetails>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.OnboardingStatus.DuplicateAccountDetails";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(OnboardingStatus.DuplicateAccountDetails.Status) },
      { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OnboardingStatus.DuplicateAccountDetails {
      return new OnboardingStatus.DuplicateAccountDetails().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OnboardingStatus.DuplicateAccountDetails {
      return new OnboardingStatus.DuplicateAccountDetails().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OnboardingStatus.DuplicateAccountDetails {
      return new OnboardingStatus.DuplicateAccountDetails().fromJsonString(jsonString, options);
    }

    static equals(a: OnboardingStatus.DuplicateAccountDetails | PlainMessage<OnboardingStatus.DuplicateAccountDetails> | undefined, b: OnboardingStatus.DuplicateAccountDetails | PlainMessage<OnboardingStatus.DuplicateAccountDetails> | undefined): boolean {
      return proto3.util.equals(OnboardingStatus.DuplicateAccountDetails, a, b);
    }

    static _enums: {
      Status: typeof OnboardingStatus.DuplicateAccountDetails.Status,
    };
  }
}

export namespace OnboardingStatus.DuplicateAccountDetails {
  /**
   * @generated from enum web.public.OnboardingStatus.DuplicateAccountDetails.Status
   */
  export enum Status {
    /**
     * @generated from enum value: NO_MATCH = 0;
     */
    NO_MATCH = 0,

    /**
     * @generated from enum value: ONE_MATCH = 1;
     */
    ONE_MATCH = 1,

    /**
     * @generated from enum value: MULTIPLE_MATCHES = 2;
     */
    MULTIPLE_MATCHES = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(OnboardingStatus.DuplicateAccountDetails.Status)
  proto3.util.setEnumType(OnboardingStatus.DuplicateAccountDetails.Status, "web.public.OnboardingStatus.DuplicateAccountDetails.Status", [
    { no: 0, name: "NO_MATCH" },
    { no: 1, name: "ONE_MATCH" },
    { no: 2, name: "MULTIPLE_MATCHES" },
  ]);
}

export namespace OnboardingStatus {
  /**
   * @generated from message web.public.OnboardingStatus.InstatouchInfo
   */
  export class InstatouchInfo extends Message<OnboardingStatus.InstatouchInfo> {
    /**
     * @generated from field: web.public.OnboardingStatus.InstatouchInfo.Status status = 1;
     */
    status = OnboardingStatus.InstatouchInfo.Status.UNKNOWN;

    /**
     * @generated from field: string partial_ssn = 2;
     */
    partialSsn = "";

    /**
     * @generated from field: string partial_dob = 3;
     */
    partialDob = "";

    constructor(data?: PartialMessage<OnboardingStatus.InstatouchInfo>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.OnboardingStatus.InstatouchInfo";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(OnboardingStatus.InstatouchInfo.Status) },
      { no: 2, name: "partial_ssn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 3, name: "partial_dob", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OnboardingStatus.InstatouchInfo {
      return new OnboardingStatus.InstatouchInfo().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OnboardingStatus.InstatouchInfo {
      return new OnboardingStatus.InstatouchInfo().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OnboardingStatus.InstatouchInfo {
      return new OnboardingStatus.InstatouchInfo().fromJsonString(jsonString, options);
    }

    static equals(a: OnboardingStatus.InstatouchInfo | PlainMessage<OnboardingStatus.InstatouchInfo> | undefined, b: OnboardingStatus.InstatouchInfo | PlainMessage<OnboardingStatus.InstatouchInfo> | undefined): boolean {
      return proto3.util.equals(OnboardingStatus.InstatouchInfo, a, b);
    }

    static _enums: {
      Status: typeof OnboardingStatus.InstatouchInfo.Status,
    };
  }
}

export namespace OnboardingStatus.InstatouchInfo {
  /**
   * @generated from enum web.public.OnboardingStatus.InstatouchInfo.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: ONBOARDING = 1;
     */
    ONBOARDING = 1,

    /**
     * @generated from enum value: RISKY_PHONE = 2;
     */
    RISKY_PHONE = 2,

    /**
     * @generated from enum value: NO_USER_FOUND = 3;
     */
    NO_USER_FOUND = 3,

    /**
     * @generated from enum value: USER_FOUND = 4;
     */
    USER_FOUND = 4,
  }
  // Retrieve enum metadata with: proto3.getEnumType(OnboardingStatus.InstatouchInfo.Status)
  proto3.util.setEnumType(OnboardingStatus.InstatouchInfo.Status, "web.public.OnboardingStatus.InstatouchInfo.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "ONBOARDING" },
    { no: 2, name: "RISKY_PHONE" },
    { no: 3, name: "NO_USER_FOUND" },
    { no: 4, name: "USER_FOUND" },
  ]);
}

/**
 * @generated from message web.public.GetOnboardingStatusResponse
 */
export class GetOnboardingStatusResponse extends Message<GetOnboardingStatusResponse> {
  /**
   * @generated from field: web.public.OnboardingStatus status = 1;
   */
  status?: OnboardingStatus;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<GetOnboardingStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetOnboardingStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "message", T: OnboardingStatus },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOnboardingStatusResponse {
    return new GetOnboardingStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOnboardingStatusResponse {
    return new GetOnboardingStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOnboardingStatusResponse {
    return new GetOnboardingStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOnboardingStatusResponse | PlainMessage<GetOnboardingStatusResponse> | undefined, b: GetOnboardingStatusResponse | PlainMessage<GetOnboardingStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetOnboardingStatusResponse, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetPersonaVerificationResponse
 */
export class GetPersonaVerificationResponse extends Message<GetPersonaVerificationResponse> {
  /**
   * @generated from field: web.public.GetPersonaVerificationResponse.Status status = 1;
   */
  status = GetPersonaVerificationResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: string persona_verification_link = 3;
   */
  personaVerificationLink = "";

  constructor(data?: PartialMessage<GetPersonaVerificationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetPersonaVerificationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetPersonaVerificationResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "persona_verification_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPersonaVerificationResponse {
    return new GetPersonaVerificationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPersonaVerificationResponse {
    return new GetPersonaVerificationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPersonaVerificationResponse {
    return new GetPersonaVerificationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPersonaVerificationResponse | PlainMessage<GetPersonaVerificationResponse> | undefined, b: GetPersonaVerificationResponse | PlainMessage<GetPersonaVerificationResponse> | undefined): boolean {
    return proto3.util.equals(GetPersonaVerificationResponse, a, b);
  }

  static _enums: {
    Status: typeof GetPersonaVerificationResponse.Status,
  };
}

export namespace GetPersonaVerificationResponse {
  /**
   * @generated from enum web.public.GetPersonaVerificationResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetPersonaVerificationResponse.Status)
  proto3.util.setEnumType(GetPersonaVerificationResponse.Status, "web.public.GetPersonaVerificationResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.CompletePersonaAddressVerificationRequest
 */
export class CompletePersonaAddressVerificationRequest extends Message<CompletePersonaAddressVerificationRequest> {
  /**
   * @generated from field: string user_token = 1;
   */
  userToken = "";

  constructor(data?: PartialMessage<CompletePersonaAddressVerificationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CompletePersonaAddressVerificationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompletePersonaAddressVerificationRequest {
    return new CompletePersonaAddressVerificationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompletePersonaAddressVerificationRequest {
    return new CompletePersonaAddressVerificationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompletePersonaAddressVerificationRequest {
    return new CompletePersonaAddressVerificationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CompletePersonaAddressVerificationRequest | PlainMessage<CompletePersonaAddressVerificationRequest> | undefined, b: CompletePersonaAddressVerificationRequest | PlainMessage<CompletePersonaAddressVerificationRequest> | undefined): boolean {
    return proto3.util.equals(CompletePersonaAddressVerificationRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.CompletePersonaAddressVerificationResponse
 */
export class CompletePersonaAddressVerificationResponse extends Message<CompletePersonaAddressVerificationResponse> {
  /**
   * @generated from field: web.public.CompletePersonaAddressVerificationResponse.Status status = 1;
   */
  status = CompletePersonaAddressVerificationResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<CompletePersonaAddressVerificationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CompletePersonaAddressVerificationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(CompletePersonaAddressVerificationResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompletePersonaAddressVerificationResponse {
    return new CompletePersonaAddressVerificationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompletePersonaAddressVerificationResponse {
    return new CompletePersonaAddressVerificationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompletePersonaAddressVerificationResponse {
    return new CompletePersonaAddressVerificationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CompletePersonaAddressVerificationResponse | PlainMessage<CompletePersonaAddressVerificationResponse> | undefined, b: CompletePersonaAddressVerificationResponse | PlainMessage<CompletePersonaAddressVerificationResponse> | undefined): boolean {
    return proto3.util.equals(CompletePersonaAddressVerificationResponse, a, b);
  }

  static _enums: {
    Status: typeof CompletePersonaAddressVerificationResponse.Status,
  };
}

export namespace CompletePersonaAddressVerificationResponse {
  /**
   * @generated from enum web.public.CompletePersonaAddressVerificationResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CompletePersonaAddressVerificationResponse.Status)
  proto3.util.setEnumType(CompletePersonaAddressVerificationResponse.Status, "web.public.CompletePersonaAddressVerificationResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.CreateUserRequest
 */
export class CreateUserRequest extends Message<CreateUserRequest> {
  /**
   * Which type of account the user is onboarding for
   *
   * @generated from field: string email = 1;
   */
  email = "";

  /**
   * @generated from field: string password = 2;
   */
  password = "";

  /**
   * @generated from field: string referrer_token = 3;
   */
  referrerToken = "";

  /**
   * @generated from field: string signup_token = 4;
   */
  signupToken = "";

  /**
   * @generated from field: web.public.OnboardingStatus.SignupType signup_type = 5;
   */
  signupType = OnboardingStatus.SignupType.CREDIT;

  constructor(data?: PartialMessage<CreateUserRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CreateUserRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "referrer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "signup_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "signup_type", kind: "enum", T: proto3.getEnumType(OnboardingStatus.SignupType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateUserRequest {
    return new CreateUserRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateUserRequest {
    return new CreateUserRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateUserRequest {
    return new CreateUserRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateUserRequest | PlainMessage<CreateUserRequest> | undefined, b: CreateUserRequest | PlainMessage<CreateUserRequest> | undefined): boolean {
    return proto3.util.equals(CreateUserRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.CreateUserResponse
 */
export class CreateUserResponse extends Message<CreateUserResponse> {
  /**
   * @generated from field: web.public.CreateUserResponse.Status status = 1;
   */
  status = CreateUserResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.OnboardingStatus onboarding_status = 3;
   */
  onboardingStatus?: OnboardingStatus;

  /**
   * @generated from field: string user_token = 4;
   */
  userToken = "";

  /**
   * @generated from field: bool mfa_required = 5;
   */
  mfaRequired = false;

  constructor(data?: PartialMessage<CreateUserResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CreateUserResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(CreateUserResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "onboarding_status", kind: "message", T: OnboardingStatus },
    { no: 4, name: "user_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "mfa_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateUserResponse {
    return new CreateUserResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateUserResponse {
    return new CreateUserResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateUserResponse {
    return new CreateUserResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateUserResponse | PlainMessage<CreateUserResponse> | undefined, b: CreateUserResponse | PlainMessage<CreateUserResponse> | undefined): boolean {
    return proto3.util.equals(CreateUserResponse, a, b);
  }

  static _enums: {
    Status: typeof CreateUserResponse.Status,
  };
}

export namespace CreateUserResponse {
  /**
   * @generated from enum web.public.CreateUserResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: CREATED = 1;
     */
    CREATED = 1,

    /**
     * @generated from enum value: TAKEN = 2;
     */
    TAKEN = 2,

    /**
     * @generated from enum value: AUTHENTICATED = 3;
     */
    AUTHENTICATED = 3,

    /**
     * @generated from enum value: FAILED = 4;
     */
    FAILED = 4,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CreateUserResponse.Status)
  proto3.util.setEnumType(CreateUserResponse.Status, "web.public.CreateUserResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "CREATED" },
    { no: 2, name: "TAKEN" },
    { no: 3, name: "AUTHENTICATED" },
    { no: 4, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.UpdateEmailRequest
 */
export class UpdateEmailRequest extends Message<UpdateEmailRequest> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  constructor(data?: PartialMessage<UpdateEmailRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdateEmailRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateEmailRequest {
    return new UpdateEmailRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateEmailRequest {
    return new UpdateEmailRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateEmailRequest {
    return new UpdateEmailRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateEmailRequest | PlainMessage<UpdateEmailRequest> | undefined, b: UpdateEmailRequest | PlainMessage<UpdateEmailRequest> | undefined): boolean {
    return proto3.util.equals(UpdateEmailRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.UpdateEmailResponse
 */
export class UpdateEmailResponse extends Message<UpdateEmailResponse> {
  /**
   * @generated from field: web.public.UpdateEmailResponse.Status status = 1;
   */
  status = UpdateEmailResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.OnboardingStatus onboarding_status = 3;
   */
  onboardingStatus?: OnboardingStatus;

  constructor(data?: PartialMessage<UpdateEmailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdateEmailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(UpdateEmailResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "onboarding_status", kind: "message", T: OnboardingStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateEmailResponse {
    return new UpdateEmailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateEmailResponse {
    return new UpdateEmailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateEmailResponse {
    return new UpdateEmailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateEmailResponse | PlainMessage<UpdateEmailResponse> | undefined, b: UpdateEmailResponse | PlainMessage<UpdateEmailResponse> | undefined): boolean {
    return proto3.util.equals(UpdateEmailResponse, a, b);
  }

  static _enums: {
    Status: typeof UpdateEmailResponse.Status,
  };
}

export namespace UpdateEmailResponse {
  /**
   * @generated from enum web.public.UpdateEmailResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: CREATED = 1;
     */
    CREATED = 1,

    /**
     * @generated from enum value: TAKEN = 2;
     */
    TAKEN = 2,

    /**
     * @generated from enum value: FAILED = 3;
     */
    FAILED = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UpdateEmailResponse.Status)
  proto3.util.setEnumType(UpdateEmailResponse.Status, "web.public.UpdateEmailResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "CREATED" },
    { no: 2, name: "TAKEN" },
    { no: 3, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.ConfirmEmailRequest
 */
export class ConfirmEmailRequest extends Message<ConfirmEmailRequest> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: string email = 2;
   */
  email = "";

  constructor(data?: PartialMessage<ConfirmEmailRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ConfirmEmailRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConfirmEmailRequest {
    return new ConfirmEmailRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConfirmEmailRequest {
    return new ConfirmEmailRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConfirmEmailRequest {
    return new ConfirmEmailRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ConfirmEmailRequest | PlainMessage<ConfirmEmailRequest> | undefined, b: ConfirmEmailRequest | PlainMessage<ConfirmEmailRequest> | undefined): boolean {
    return proto3.util.equals(ConfirmEmailRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.ConfirmEmailResponse
 */
export class ConfirmEmailResponse extends Message<ConfirmEmailResponse> {
  /**
   * @generated from field: web.public.ConfirmEmailResponse.Status status = 1;
   */
  status = ConfirmEmailResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.OnboardingStatus onboarding_status = 3;
   */
  onboardingStatus?: OnboardingStatus;

  constructor(data?: PartialMessage<ConfirmEmailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ConfirmEmailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ConfirmEmailResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "onboarding_status", kind: "message", T: OnboardingStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConfirmEmailResponse {
    return new ConfirmEmailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConfirmEmailResponse {
    return new ConfirmEmailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConfirmEmailResponse {
    return new ConfirmEmailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ConfirmEmailResponse | PlainMessage<ConfirmEmailResponse> | undefined, b: ConfirmEmailResponse | PlainMessage<ConfirmEmailResponse> | undefined): boolean {
    return proto3.util.equals(ConfirmEmailResponse, a, b);
  }

  static _enums: {
    Status: typeof ConfirmEmailResponse.Status,
  };
}

export namespace ConfirmEmailResponse {
  /**
   * @generated from enum web.public.ConfirmEmailResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ConfirmEmailResponse.Status)
  proto3.util.setEnumType(ConfirmEmailResponse.Status, "web.public.ConfirmEmailResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.UpdateNameRequest
 */
export class UpdateNameRequest extends Message<UpdateNameRequest> {
  /**
   * @generated from field: string given_name = 1;
   */
  givenName = "";

  /**
   * @generated from field: string surname = 2;
   */
  surname = "";

  /**
   * @generated from field: string middle_name = 3;
   */
  middleName = "";

  constructor(data?: PartialMessage<UpdateNameRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdateNameRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "given_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "surname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "middle_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateNameRequest {
    return new UpdateNameRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateNameRequest {
    return new UpdateNameRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateNameRequest {
    return new UpdateNameRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateNameRequest | PlainMessage<UpdateNameRequest> | undefined, b: UpdateNameRequest | PlainMessage<UpdateNameRequest> | undefined): boolean {
    return proto3.util.equals(UpdateNameRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.UpdateNameResponse
 */
export class UpdateNameResponse extends Message<UpdateNameResponse> {
  /**
   * @generated from field: web.public.UpdateNameResponse.Status status = 1;
   */
  status = UpdateNameResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.OnboardingStatus onboarding_status = 3;
   */
  onboardingStatus?: OnboardingStatus;

  constructor(data?: PartialMessage<UpdateNameResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdateNameResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(UpdateNameResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "onboarding_status", kind: "message", T: OnboardingStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateNameResponse {
    return new UpdateNameResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateNameResponse {
    return new UpdateNameResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateNameResponse {
    return new UpdateNameResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateNameResponse | PlainMessage<UpdateNameResponse> | undefined, b: UpdateNameResponse | PlainMessage<UpdateNameResponse> | undefined): boolean {
    return proto3.util.equals(UpdateNameResponse, a, b);
  }

  static _enums: {
    Status: typeof UpdateNameResponse.Status,
  };
}

export namespace UpdateNameResponse {
  /**
   * @generated from enum web.public.UpdateNameResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UpdateNameResponse.Status)
  proto3.util.setEnumType(UpdateNameResponse.Status, "web.public.UpdateNameResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.UpdatePhoneRequest
 */
export class UpdatePhoneRequest extends Message<UpdatePhoneRequest> {
  /**
   * @generated from field: string phone = 1;
   */
  phone = "";

  /**
   * @generated from field: bool accepted_marketing_terms = 2;
   */
  acceptedMarketingTerms = false;

  constructor(data?: PartialMessage<UpdatePhoneRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdatePhoneRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "accepted_marketing_terms", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdatePhoneRequest {
    return new UpdatePhoneRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdatePhoneRequest {
    return new UpdatePhoneRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdatePhoneRequest {
    return new UpdatePhoneRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdatePhoneRequest | PlainMessage<UpdatePhoneRequest> | undefined, b: UpdatePhoneRequest | PlainMessage<UpdatePhoneRequest> | undefined): boolean {
    return proto3.util.equals(UpdatePhoneRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.UpdatePhoneResponse
 */
export class UpdatePhoneResponse extends Message<UpdatePhoneResponse> {
  /**
   * @generated from field: web.public.UpdatePhoneResponse.Status status = 1;
   */
  status = UpdatePhoneResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.OnboardingStatus onboarding_status = 3;
   */
  onboardingStatus?: OnboardingStatus;

  constructor(data?: PartialMessage<UpdatePhoneResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdatePhoneResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(UpdatePhoneResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "onboarding_status", kind: "message", T: OnboardingStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdatePhoneResponse {
    return new UpdatePhoneResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdatePhoneResponse {
    return new UpdatePhoneResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdatePhoneResponse {
    return new UpdatePhoneResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdatePhoneResponse | PlainMessage<UpdatePhoneResponse> | undefined, b: UpdatePhoneResponse | PlainMessage<UpdatePhoneResponse> | undefined): boolean {
    return proto3.util.equals(UpdatePhoneResponse, a, b);
  }

  static _enums: {
    Status: typeof UpdatePhoneResponse.Status,
  };
}

export namespace UpdatePhoneResponse {
  /**
   * @generated from enum web.public.UpdatePhoneResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: TAKEN = 2;
     */
    TAKEN = 2,

    /**
     * @generated from enum value: FAILED = 3;
     */
    FAILED = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UpdatePhoneResponse.Status)
  proto3.util.setEnumType(UpdatePhoneResponse.Status, "web.public.UpdatePhoneResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "TAKEN" },
    { no: 3, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.GetPhoneValidationRequest
 */
export class GetPhoneValidationRequest extends Message<GetPhoneValidationRequest> {
  /**
   * @generated from field: string phone = 1;
   */
  phone = "";

  constructor(data?: PartialMessage<GetPhoneValidationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetPhoneValidationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPhoneValidationRequest {
    return new GetPhoneValidationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPhoneValidationRequest {
    return new GetPhoneValidationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPhoneValidationRequest {
    return new GetPhoneValidationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPhoneValidationRequest | PlainMessage<GetPhoneValidationRequest> | undefined, b: GetPhoneValidationRequest | PlainMessage<GetPhoneValidationRequest> | undefined): boolean {
    return proto3.util.equals(GetPhoneValidationRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetPhoneValidationResponse
 */
export class GetPhoneValidationResponse extends Message<GetPhoneValidationResponse> {
  /**
   * @generated from field: web.public.GetPhoneValidationResponse.Status status = 1;
   */
  status = GetPhoneValidationResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.OnboardingStatus onboarding_status = 3;
   */
  onboardingStatus?: OnboardingStatus;

  constructor(data?: PartialMessage<GetPhoneValidationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetPhoneValidationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetPhoneValidationResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "onboarding_status", kind: "message", T: OnboardingStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPhoneValidationResponse {
    return new GetPhoneValidationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPhoneValidationResponse {
    return new GetPhoneValidationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPhoneValidationResponse {
    return new GetPhoneValidationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPhoneValidationResponse | PlainMessage<GetPhoneValidationResponse> | undefined, b: GetPhoneValidationResponse | PlainMessage<GetPhoneValidationResponse> | undefined): boolean {
    return proto3.util.equals(GetPhoneValidationResponse, a, b);
  }

  static _enums: {
    Status: typeof GetPhoneValidationResponse.Status,
  };
}

export namespace GetPhoneValidationResponse {
  /**
   * @generated from enum web.public.GetPhoneValidationResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: VALID = 1;
     */
    VALID = 1,

    /**
     * @generated from enum value: INVALID = 2;
     */
    INVALID = 2,

    /**
     * @generated from enum value: WAITING = 3;
     */
    WAITING = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetPhoneValidationResponse.Status)
  proto3.util.setEnumType(GetPhoneValidationResponse.Status, "web.public.GetPhoneValidationResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "VALID" },
    { no: 2, name: "INVALID" },
    { no: 3, name: "WAITING" },
  ]);
}

/**
 * @generated from message web.public.GetPhoneCodeRequest
 */
export class GetPhoneCodeRequest extends Message<GetPhoneCodeRequest> {
  /**
   * @generated from field: string phone = 1;
   */
  phone = "";

  constructor(data?: PartialMessage<GetPhoneCodeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetPhoneCodeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPhoneCodeRequest {
    return new GetPhoneCodeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPhoneCodeRequest {
    return new GetPhoneCodeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPhoneCodeRequest {
    return new GetPhoneCodeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPhoneCodeRequest | PlainMessage<GetPhoneCodeRequest> | undefined, b: GetPhoneCodeRequest | PlainMessage<GetPhoneCodeRequest> | undefined): boolean {
    return proto3.util.equals(GetPhoneCodeRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetPhoneCodeResponse
 */
export class GetPhoneCodeResponse extends Message<GetPhoneCodeResponse> {
  /**
   * @generated from field: web.public.GetPhoneCodeResponse.Status status = 1;
   */
  status = GetPhoneCodeResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.OnboardingStatus onboarding_status = 3;
   */
  onboardingStatus?: OnboardingStatus;

  constructor(data?: PartialMessage<GetPhoneCodeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetPhoneCodeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetPhoneCodeResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "onboarding_status", kind: "message", T: OnboardingStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPhoneCodeResponse {
    return new GetPhoneCodeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPhoneCodeResponse {
    return new GetPhoneCodeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPhoneCodeResponse {
    return new GetPhoneCodeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPhoneCodeResponse | PlainMessage<GetPhoneCodeResponse> | undefined, b: GetPhoneCodeResponse | PlainMessage<GetPhoneCodeResponse> | undefined): boolean {
    return proto3.util.equals(GetPhoneCodeResponse, a, b);
  }

  static _enums: {
    Status: typeof GetPhoneCodeResponse.Status,
  };
}

export namespace GetPhoneCodeResponse {
  /**
   * @generated from enum web.public.GetPhoneCodeResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,

    /**
     * @generated from enum value: ALREADY_CONFIRMED = 3;
     */
    ALREADY_CONFIRMED = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetPhoneCodeResponse.Status)
  proto3.util.setEnumType(GetPhoneCodeResponse.Status, "web.public.GetPhoneCodeResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
    { no: 3, name: "ALREADY_CONFIRMED" },
  ]);
}

/**
 * @generated from message web.public.ConfirmPhoneRequest
 */
export class ConfirmPhoneRequest extends Message<ConfirmPhoneRequest> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: string phone = 2;
   */
  phone = "";

  constructor(data?: PartialMessage<ConfirmPhoneRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ConfirmPhoneRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConfirmPhoneRequest {
    return new ConfirmPhoneRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConfirmPhoneRequest {
    return new ConfirmPhoneRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConfirmPhoneRequest {
    return new ConfirmPhoneRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ConfirmPhoneRequest | PlainMessage<ConfirmPhoneRequest> | undefined, b: ConfirmPhoneRequest | PlainMessage<ConfirmPhoneRequest> | undefined): boolean {
    return proto3.util.equals(ConfirmPhoneRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.ConfirmPhoneResponse
 */
export class ConfirmPhoneResponse extends Message<ConfirmPhoneResponse> {
  /**
   * @generated from field: web.public.ConfirmPhoneResponse.Status status = 1;
   */
  status = ConfirmPhoneResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.OnboardingStatus onboarding_status = 3;
   */
  onboardingStatus?: OnboardingStatus;

  constructor(data?: PartialMessage<ConfirmPhoneResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ConfirmPhoneResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ConfirmPhoneResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "onboarding_status", kind: "message", T: OnboardingStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConfirmPhoneResponse {
    return new ConfirmPhoneResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConfirmPhoneResponse {
    return new ConfirmPhoneResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConfirmPhoneResponse {
    return new ConfirmPhoneResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ConfirmPhoneResponse | PlainMessage<ConfirmPhoneResponse> | undefined, b: ConfirmPhoneResponse | PlainMessage<ConfirmPhoneResponse> | undefined): boolean {
    return proto3.util.equals(ConfirmPhoneResponse, a, b);
  }

  static _enums: {
    Status: typeof ConfirmPhoneResponse.Status,
  };
}

export namespace ConfirmPhoneResponse {
  /**
   * @generated from enum web.public.ConfirmPhoneResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ConfirmPhoneResponse.Status)
  proto3.util.setEnumType(ConfirmPhoneResponse.Status, "web.public.ConfirmPhoneResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.UpdateDOBRequest
 */
export class UpdateDOBRequest extends Message<UpdateDOBRequest> {
  /**
   * @generated from field: string dob = 1;
   */
  dob = "";

  constructor(data?: PartialMessage<UpdateDOBRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdateDOBRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dob", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateDOBRequest {
    return new UpdateDOBRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateDOBRequest {
    return new UpdateDOBRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateDOBRequest {
    return new UpdateDOBRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateDOBRequest | PlainMessage<UpdateDOBRequest> | undefined, b: UpdateDOBRequest | PlainMessage<UpdateDOBRequest> | undefined): boolean {
    return proto3.util.equals(UpdateDOBRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.UpdateDOBResponse
 */
export class UpdateDOBResponse extends Message<UpdateDOBResponse> {
  /**
   * @generated from field: web.public.UpdateDOBResponse.Status status = 1;
   */
  status = UpdateDOBResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.OnboardingStatus onboarding_status = 3;
   */
  onboardingStatus?: OnboardingStatus;

  constructor(data?: PartialMessage<UpdateDOBResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdateDOBResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(UpdateDOBResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "onboarding_status", kind: "message", T: OnboardingStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateDOBResponse {
    return new UpdateDOBResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateDOBResponse {
    return new UpdateDOBResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateDOBResponse {
    return new UpdateDOBResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateDOBResponse | PlainMessage<UpdateDOBResponse> | undefined, b: UpdateDOBResponse | PlainMessage<UpdateDOBResponse> | undefined): boolean {
    return proto3.util.equals(UpdateDOBResponse, a, b);
  }

  static _enums: {
    Status: typeof UpdateDOBResponse.Status,
  };
}

export namespace UpdateDOBResponse {
  /**
   * @generated from enum web.public.UpdateDOBResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UpdateDOBResponse.Status)
  proto3.util.setEnumType(UpdateDOBResponse.Status, "web.public.UpdateDOBResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.UpdateSSNRequest
 */
export class UpdateSSNRequest extends Message<UpdateSSNRequest> {
  /**
   * @generated from field: string ssn = 1;
   */
  ssn = "";

  constructor(data?: PartialMessage<UpdateSSNRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdateSSNRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ssn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSSNRequest {
    return new UpdateSSNRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSSNRequest {
    return new UpdateSSNRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSSNRequest {
    return new UpdateSSNRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSSNRequest | PlainMessage<UpdateSSNRequest> | undefined, b: UpdateSSNRequest | PlainMessage<UpdateSSNRequest> | undefined): boolean {
    return proto3.util.equals(UpdateSSNRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.UpdateSSNResponse
 */
export class UpdateSSNResponse extends Message<UpdateSSNResponse> {
  /**
   * @generated from field: web.public.UpdateSSNResponse.Status status = 1;
   */
  status = UpdateSSNResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.OnboardingStatus onboarding_status = 3;
   */
  onboardingStatus?: OnboardingStatus;

  constructor(data?: PartialMessage<UpdateSSNResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdateSSNResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(UpdateSSNResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "onboarding_status", kind: "message", T: OnboardingStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSSNResponse {
    return new UpdateSSNResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSSNResponse {
    return new UpdateSSNResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSSNResponse {
    return new UpdateSSNResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSSNResponse | PlainMessage<UpdateSSNResponse> | undefined, b: UpdateSSNResponse | PlainMessage<UpdateSSNResponse> | undefined): boolean {
    return proto3.util.equals(UpdateSSNResponse, a, b);
  }

  static _enums: {
    Status: typeof UpdateSSNResponse.Status,
  };
}

export namespace UpdateSSNResponse {
  /**
   * @generated from enum web.public.UpdateSSNResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UpdateSSNResponse.Status)
  proto3.util.setEnumType(UpdateSSNResponse.Status, "web.public.UpdateSSNResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.UpdateAddressRequest
 */
export class UpdateAddressRequest extends Message<UpdateAddressRequest> {
  /**
   * @generated from field: string address_line_1 = 1;
   */
  addressLine1 = "";

  /**
   * @generated from field: string address_line_2 = 2;
   */
  addressLine2 = "";

  /**
   * @generated from field: string city = 3;
   */
  city = "";

  /**
   * @generated from field: string state = 4;
   */
  state = "";

  /**
   * @generated from field: string zip = 5;
   */
  zip = "";

  constructor(data?: PartialMessage<UpdateAddressRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdateAddressRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "address_line_1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "address_line_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "zip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAddressRequest {
    return new UpdateAddressRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAddressRequest {
    return new UpdateAddressRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAddressRequest {
    return new UpdateAddressRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAddressRequest | PlainMessage<UpdateAddressRequest> | undefined, b: UpdateAddressRequest | PlainMessage<UpdateAddressRequest> | undefined): boolean {
    return proto3.util.equals(UpdateAddressRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.UpdateAddressResponse
 */
export class UpdateAddressResponse extends Message<UpdateAddressResponse> {
  /**
   * @generated from field: web.public.UpdateAddressResponse.Status status = 1;
   */
  status = UpdateAddressResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.OnboardingStatus onboarding_status = 3;
   */
  onboardingStatus?: OnboardingStatus;

  constructor(data?: PartialMessage<UpdateAddressResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdateAddressResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(UpdateAddressResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "onboarding_status", kind: "message", T: OnboardingStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAddressResponse {
    return new UpdateAddressResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAddressResponse {
    return new UpdateAddressResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAddressResponse {
    return new UpdateAddressResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAddressResponse | PlainMessage<UpdateAddressResponse> | undefined, b: UpdateAddressResponse | PlainMessage<UpdateAddressResponse> | undefined): boolean {
    return proto3.util.equals(UpdateAddressResponse, a, b);
  }

  static _enums: {
    Status: typeof UpdateAddressResponse.Status,
  };
}

export namespace UpdateAddressResponse {
  /**
   * @generated from enum web.public.UpdateAddressResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UpdateAddressResponse.Status)
  proto3.util.setEnumType(UpdateAddressResponse.Status, "web.public.UpdateAddressResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.UpdateRenterStatusRequest
 */
export class UpdateRenterStatusRequest extends Message<UpdateRenterStatusRequest> {
  /**
   * @generated from field: web.public.UpdateRenterStatusRequest.RenterStatus renter_status = 1;
   */
  renterStatus = UpdateRenterStatusRequest.RenterStatus.UNKNOWN;

  constructor(data?: PartialMessage<UpdateRenterStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdateRenterStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "renter_status", kind: "enum", T: proto3.getEnumType(UpdateRenterStatusRequest.RenterStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRenterStatusRequest {
    return new UpdateRenterStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRenterStatusRequest {
    return new UpdateRenterStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRenterStatusRequest {
    return new UpdateRenterStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRenterStatusRequest | PlainMessage<UpdateRenterStatusRequest> | undefined, b: UpdateRenterStatusRequest | PlainMessage<UpdateRenterStatusRequest> | undefined): boolean {
    return proto3.util.equals(UpdateRenterStatusRequest, a, b);
  }

  static _enums: {
    RenterStatus: typeof UpdateRenterStatusRequest.RenterStatus,
  };
}

export namespace UpdateRenterStatusRequest {
  /**
   * @generated from enum web.public.UpdateRenterStatusRequest.RenterStatus
   */
  export enum RenterStatus {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: RENTER = 1;
     */
    RENTER = 1,

    /**
     * @generated from enum value: OWNER = 2;
     */
    OWNER = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UpdateRenterStatusRequest.RenterStatus)
  proto3.util.setEnumType(UpdateRenterStatusRequest.RenterStatus, "web.public.UpdateRenterStatusRequest.RenterStatus", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "RENTER" },
    { no: 2, name: "OWNER" },
  ]);
}

/**
 * @generated from message web.public.UpdateRenterStatusResponse
 */
export class UpdateRenterStatusResponse extends Message<UpdateRenterStatusResponse> {
  /**
   * @generated from field: web.public.UpdateRenterStatusResponse.Status status = 1;
   */
  status = UpdateRenterStatusResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.OnboardingStatus onboarding_status = 3;
   */
  onboardingStatus?: OnboardingStatus;

  constructor(data?: PartialMessage<UpdateRenterStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdateRenterStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(UpdateRenterStatusResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "onboarding_status", kind: "message", T: OnboardingStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRenterStatusResponse {
    return new UpdateRenterStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRenterStatusResponse {
    return new UpdateRenterStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRenterStatusResponse {
    return new UpdateRenterStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRenterStatusResponse | PlainMessage<UpdateRenterStatusResponse> | undefined, b: UpdateRenterStatusResponse | PlainMessage<UpdateRenterStatusResponse> | undefined): boolean {
    return proto3.util.equals(UpdateRenterStatusResponse, a, b);
  }

  static _enums: {
    Status: typeof UpdateRenterStatusResponse.Status,
  };
}

export namespace UpdateRenterStatusResponse {
  /**
   * @generated from enum web.public.UpdateRenterStatusResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UpdateRenterStatusResponse.Status)
  proto3.util.setEnumType(UpdateRenterStatusResponse.Status, "web.public.UpdateRenterStatusResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.CompleteFormRequest
 */
export class CompleteFormRequest extends Message<CompleteFormRequest> {
  constructor(data?: PartialMessage<CompleteFormRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CompleteFormRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompleteFormRequest {
    return new CompleteFormRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompleteFormRequest {
    return new CompleteFormRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompleteFormRequest {
    return new CompleteFormRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CompleteFormRequest | PlainMessage<CompleteFormRequest> | undefined, b: CompleteFormRequest | PlainMessage<CompleteFormRequest> | undefined): boolean {
    return proto3.util.equals(CompleteFormRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.CompleteFormResponse
 */
export class CompleteFormResponse extends Message<CompleteFormResponse> {
  /**
   * @generated from field: web.public.CompleteFormResponse.Status status = 1;
   */
  status = CompleteFormResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<CompleteFormResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CompleteFormResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(CompleteFormResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompleteFormResponse {
    return new CompleteFormResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompleteFormResponse {
    return new CompleteFormResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompleteFormResponse {
    return new CompleteFormResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CompleteFormResponse | PlainMessage<CompleteFormResponse> | undefined, b: CompleteFormResponse | PlainMessage<CompleteFormResponse> | undefined): boolean {
    return proto3.util.equals(CompleteFormResponse, a, b);
  }

  static _enums: {
    Status: typeof CompleteFormResponse.Status,
  };
}

export namespace CompleteFormResponse {
  /**
   * @generated from enum web.public.CompleteFormResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CompleteFormResponse.Status)
  proto3.util.setEnumType(CompleteFormResponse.Status, "web.public.CompleteFormResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.RetryPiiRequest
 */
export class RetryPiiRequest extends Message<RetryPiiRequest> {
  constructor(data?: PartialMessage<RetryPiiRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.RetryPiiRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RetryPiiRequest {
    return new RetryPiiRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RetryPiiRequest {
    return new RetryPiiRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RetryPiiRequest {
    return new RetryPiiRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RetryPiiRequest | PlainMessage<RetryPiiRequest> | undefined, b: RetryPiiRequest | PlainMessage<RetryPiiRequest> | undefined): boolean {
    return proto3.util.equals(RetryPiiRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.RetryPiiResponse
 */
export class RetryPiiResponse extends Message<RetryPiiResponse> {
  /**
   * @generated from field: web.public.RetryPiiResponse.Status status = 1;
   */
  status = RetryPiiResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.OnboardingStatus onboarding_status = 3;
   */
  onboardingStatus?: OnboardingStatus;

  constructor(data?: PartialMessage<RetryPiiResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.RetryPiiResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(RetryPiiResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "onboarding_status", kind: "message", T: OnboardingStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RetryPiiResponse {
    return new RetryPiiResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RetryPiiResponse {
    return new RetryPiiResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RetryPiiResponse {
    return new RetryPiiResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RetryPiiResponse | PlainMessage<RetryPiiResponse> | undefined, b: RetryPiiResponse | PlainMessage<RetryPiiResponse> | undefined): boolean {
    return proto3.util.equals(RetryPiiResponse, a, b);
  }

  static _enums: {
    Status: typeof RetryPiiResponse.Status,
  };
}

export namespace RetryPiiResponse {
  /**
   * @generated from enum web.public.RetryPiiResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(RetryPiiResponse.Status)
  proto3.util.setEnumType(RetryPiiResponse.Status, "web.public.RetryPiiResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.UserIncomeRange
 */
export class UserIncomeRange extends Message<UserIncomeRange> {
  /**
   * @generated from field: uint32 low = 1;
   */
  low = 0;

  /**
   * @generated from field: uint32 high = 2;
   */
  high = 0;

  constructor(data?: PartialMessage<UserIncomeRange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UserIncomeRange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "low", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "high", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserIncomeRange {
    return new UserIncomeRange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserIncomeRange {
    return new UserIncomeRange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserIncomeRange {
    return new UserIncomeRange().fromJsonString(jsonString, options);
  }

  static equals(a: UserIncomeRange | PlainMessage<UserIncomeRange> | undefined, b: UserIncomeRange | PlainMessage<UserIncomeRange> | undefined): boolean {
    return proto3.util.equals(UserIncomeRange, a, b);
  }

  static _enums: {
  };
}

/**
 * DEPRECATED
 *
 * @generated from message web.public.CreditLineIncreaseEligibilityRequest
 */
export class CreditLineIncreaseEligibilityRequest extends Message<CreditLineIncreaseEligibilityRequest> {
  constructor(data?: PartialMessage<CreditLineIncreaseEligibilityRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CreditLineIncreaseEligibilityRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditLineIncreaseEligibilityRequest {
    return new CreditLineIncreaseEligibilityRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditLineIncreaseEligibilityRequest {
    return new CreditLineIncreaseEligibilityRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditLineIncreaseEligibilityRequest {
    return new CreditLineIncreaseEligibilityRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreditLineIncreaseEligibilityRequest | PlainMessage<CreditLineIncreaseEligibilityRequest> | undefined, b: CreditLineIncreaseEligibilityRequest | PlainMessage<CreditLineIncreaseEligibilityRequest> | undefined): boolean {
    return proto3.util.equals(CreditLineIncreaseEligibilityRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * DEPRECATED
 *
 * @generated from message web.public.CreditLineIncreaseEligibilityResponse
 */
export class CreditLineIncreaseEligibilityResponse extends Message<CreditLineIncreaseEligibilityResponse> {
  /**
   * @generated from field: web.public.CreditLineIncreaseEligibilityResponse.Status status = 1;
   */
  status = CreditLineIncreaseEligibilityResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: bool eligible = 3;
   */
  eligible = false;

  /**
   * @generated from field: repeated web.public.UserIncomeRange income_ranges = 4;
   */
  incomeRanges: UserIncomeRange[] = [];

  constructor(data?: PartialMessage<CreditLineIncreaseEligibilityResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CreditLineIncreaseEligibilityResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(CreditLineIncreaseEligibilityResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "eligible", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "income_ranges", kind: "message", T: UserIncomeRange, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditLineIncreaseEligibilityResponse {
    return new CreditLineIncreaseEligibilityResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditLineIncreaseEligibilityResponse {
    return new CreditLineIncreaseEligibilityResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditLineIncreaseEligibilityResponse {
    return new CreditLineIncreaseEligibilityResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreditLineIncreaseEligibilityResponse | PlainMessage<CreditLineIncreaseEligibilityResponse> | undefined, b: CreditLineIncreaseEligibilityResponse | PlainMessage<CreditLineIncreaseEligibilityResponse> | undefined): boolean {
    return proto3.util.equals(CreditLineIncreaseEligibilityResponse, a, b);
  }

  static _enums: {
    Status: typeof CreditLineIncreaseEligibilityResponse.Status,
  };
}

export namespace CreditLineIncreaseEligibilityResponse {
  /**
   * @generated from enum web.public.CreditLineIncreaseEligibilityResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CreditLineIncreaseEligibilityResponse.Status)
  proto3.util.setEnumType(CreditLineIncreaseEligibilityResponse.Status, "web.public.CreditLineIncreaseEligibilityResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * DEPRECATED
 *
 * @generated from message web.public.UserIncomeSelectionRequest
 */
export class UserIncomeSelectionRequest extends Message<UserIncomeSelectionRequest> {
  /**
   * @generated from field: web.public.UserIncomeRange income_range = 1;
   */
  incomeRange?: UserIncomeRange;

  constructor(data?: PartialMessage<UserIncomeSelectionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UserIncomeSelectionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "income_range", kind: "message", T: UserIncomeRange },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserIncomeSelectionRequest {
    return new UserIncomeSelectionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserIncomeSelectionRequest {
    return new UserIncomeSelectionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserIncomeSelectionRequest {
    return new UserIncomeSelectionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UserIncomeSelectionRequest | PlainMessage<UserIncomeSelectionRequest> | undefined, b: UserIncomeSelectionRequest | PlainMessage<UserIncomeSelectionRequest> | undefined): boolean {
    return proto3.util.equals(UserIncomeSelectionRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * DEPRECATED
 *
 * @generated from message web.public.UserIncomeSelectionResponse
 */
export class UserIncomeSelectionResponse extends Message<UserIncomeSelectionResponse> {
  /**
   * @generated from field: web.public.UserIncomeSelectionResponse.Status status = 1;
   */
  status = UserIncomeSelectionResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<UserIncomeSelectionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UserIncomeSelectionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(UserIncomeSelectionResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserIncomeSelectionResponse {
    return new UserIncomeSelectionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserIncomeSelectionResponse {
    return new UserIncomeSelectionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserIncomeSelectionResponse {
    return new UserIncomeSelectionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UserIncomeSelectionResponse | PlainMessage<UserIncomeSelectionResponse> | undefined, b: UserIncomeSelectionResponse | PlainMessage<UserIncomeSelectionResponse> | undefined): boolean {
    return proto3.util.equals(UserIncomeSelectionResponse, a, b);
  }

  static _enums: {
    Status: typeof UserIncomeSelectionResponse.Status,
  };
}

export namespace UserIncomeSelectionResponse {
  /**
   * @generated from enum web.public.UserIncomeSelectionResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UserIncomeSelectionResponse.Status)
  proto3.util.setEnumType(UserIncomeSelectionResponse.Status, "web.public.UserIncomeSelectionResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.JoinSignupWaitlistRequest
 */
export class JoinSignupWaitlistRequest extends Message<JoinSignupWaitlistRequest> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  constructor(data?: PartialMessage<JoinSignupWaitlistRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.JoinSignupWaitlistRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): JoinSignupWaitlistRequest {
    return new JoinSignupWaitlistRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): JoinSignupWaitlistRequest {
    return new JoinSignupWaitlistRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): JoinSignupWaitlistRequest {
    return new JoinSignupWaitlistRequest().fromJsonString(jsonString, options);
  }

  static equals(a: JoinSignupWaitlistRequest | PlainMessage<JoinSignupWaitlistRequest> | undefined, b: JoinSignupWaitlistRequest | PlainMessage<JoinSignupWaitlistRequest> | undefined): boolean {
    return proto3.util.equals(JoinSignupWaitlistRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.JoinSignupWaitlistResponse
 */
export class JoinSignupWaitlistResponse extends Message<JoinSignupWaitlistResponse> {
  /**
   * @generated from field: web.public.JoinSignupWaitlistResponse.Status status = 1;
   */
  status = JoinSignupWaitlistResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<JoinSignupWaitlistResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.JoinSignupWaitlistResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(JoinSignupWaitlistResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): JoinSignupWaitlistResponse {
    return new JoinSignupWaitlistResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): JoinSignupWaitlistResponse {
    return new JoinSignupWaitlistResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): JoinSignupWaitlistResponse {
    return new JoinSignupWaitlistResponse().fromJsonString(jsonString, options);
  }

  static equals(a: JoinSignupWaitlistResponse | PlainMessage<JoinSignupWaitlistResponse> | undefined, b: JoinSignupWaitlistResponse | PlainMessage<JoinSignupWaitlistResponse> | undefined): boolean {
    return proto3.util.equals(JoinSignupWaitlistResponse, a, b);
  }

  static _enums: {
    Status: typeof JoinSignupWaitlistResponse.Status,
  };
}

export namespace JoinSignupWaitlistResponse {
  /**
   * @generated from enum web.public.JoinSignupWaitlistResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,

    /**
     * @generated from enum value: APPROVED = 3;
     */
    APPROVED = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(JoinSignupWaitlistResponse.Status)
  proto3.util.setEnumType(JoinSignupWaitlistResponse.Status, "web.public.JoinSignupWaitlistResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
    { no: 3, name: "APPROVED" },
  ]);
}

/**
 * @generated from message web.public.CreateInstatouchUserRequest
 */
export class CreateInstatouchUserRequest extends Message<CreateInstatouchUserRequest> {
  /**
   * @generated from field: string phone = 1;
   */
  phone = "";

  /**
   * @generated from field: string partial_ssn = 2;
   */
  partialSsn = "";

  /**
   * @generated from field: string partial_dob = 3;
   */
  partialDob = "";

  /**
   * @generated from field: string zip = 4;
   */
  zip = "";

  constructor(data?: PartialMessage<CreateInstatouchUserRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CreateInstatouchUserRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "partial_ssn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "partial_dob", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "zip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateInstatouchUserRequest {
    return new CreateInstatouchUserRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateInstatouchUserRequest {
    return new CreateInstatouchUserRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateInstatouchUserRequest {
    return new CreateInstatouchUserRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateInstatouchUserRequest | PlainMessage<CreateInstatouchUserRequest> | undefined, b: CreateInstatouchUserRequest | PlainMessage<CreateInstatouchUserRequest> | undefined): boolean {
    return proto3.util.equals(CreateInstatouchUserRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.CreateInstatouchUserResponse
 */
export class CreateInstatouchUserResponse extends Message<CreateInstatouchUserResponse> {
  /**
   * @generated from field: web.public.CreateInstatouchUserResponse.Status status = 1;
   */
  status = CreateInstatouchUserResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<CreateInstatouchUserResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CreateInstatouchUserResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(CreateInstatouchUserResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateInstatouchUserResponse {
    return new CreateInstatouchUserResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateInstatouchUserResponse {
    return new CreateInstatouchUserResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateInstatouchUserResponse {
    return new CreateInstatouchUserResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateInstatouchUserResponse | PlainMessage<CreateInstatouchUserResponse> | undefined, b: CreateInstatouchUserResponse | PlainMessage<CreateInstatouchUserResponse> | undefined): boolean {
    return proto3.util.equals(CreateInstatouchUserResponse, a, b);
  }

  static _enums: {
    Status: typeof CreateInstatouchUserResponse.Status,
  };
}

export namespace CreateInstatouchUserResponse {
  /**
   * @generated from enum web.public.CreateInstatouchUserResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CreateInstatouchUserResponse.Status)
  proto3.util.setEnumType(CreateInstatouchUserResponse.Status, "web.public.CreateInstatouchUserResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.VerifyInstatouchRequest
 */
export class VerifyInstatouchRequest extends Message<VerifyInstatouchRequest> {
  constructor(data?: PartialMessage<VerifyInstatouchRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.VerifyInstatouchRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyInstatouchRequest {
    return new VerifyInstatouchRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyInstatouchRequest {
    return new VerifyInstatouchRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyInstatouchRequest {
    return new VerifyInstatouchRequest().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyInstatouchRequest | PlainMessage<VerifyInstatouchRequest> | undefined, b: VerifyInstatouchRequest | PlainMessage<VerifyInstatouchRequest> | undefined): boolean {
    return proto3.util.equals(VerifyInstatouchRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.VerifyInstatouchResponse
 */
export class VerifyInstatouchResponse extends Message<VerifyInstatouchResponse> {
  /**
   * @generated from field: web.public.VerifyInstatouchResponse.Status status = 1;
   */
  status = VerifyInstatouchResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: bool verified = 3;
   */
  verified = false;

  constructor(data?: PartialMessage<VerifyInstatouchResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.VerifyInstatouchResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(VerifyInstatouchResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyInstatouchResponse {
    return new VerifyInstatouchResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyInstatouchResponse {
    return new VerifyInstatouchResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyInstatouchResponse {
    return new VerifyInstatouchResponse().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyInstatouchResponse | PlainMessage<VerifyInstatouchResponse> | undefined, b: VerifyInstatouchResponse | PlainMessage<VerifyInstatouchResponse> | undefined): boolean {
    return proto3.util.equals(VerifyInstatouchResponse, a, b);
  }

  static _enums: {
    Status: typeof VerifyInstatouchResponse.Status,
  };
}

export namespace VerifyInstatouchResponse {
  /**
   * @generated from enum web.public.VerifyInstatouchResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,

    /**
     * @generated from enum value: PENDING = 3;
     */
    PENDING = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(VerifyInstatouchResponse.Status)
  proto3.util.setEnumType(VerifyInstatouchResponse.Status, "web.public.VerifyInstatouchResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
    { no: 3, name: "PENDING" },
  ]);
}

/**
 * @generated from message web.public.GetInstatouchPiiRequest
 */
export class GetInstatouchPiiRequest extends Message<GetInstatouchPiiRequest> {
  constructor(data?: PartialMessage<GetInstatouchPiiRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetInstatouchPiiRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetInstatouchPiiRequest {
    return new GetInstatouchPiiRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetInstatouchPiiRequest {
    return new GetInstatouchPiiRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetInstatouchPiiRequest {
    return new GetInstatouchPiiRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetInstatouchPiiRequest | PlainMessage<GetInstatouchPiiRequest> | undefined, b: GetInstatouchPiiRequest | PlainMessage<GetInstatouchPiiRequest> | undefined): boolean {
    return proto3.util.equals(GetInstatouchPiiRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetInstatouchPiiResponse
 */
export class GetInstatouchPiiResponse extends Message<GetInstatouchPiiResponse> {
  /**
   * @generated from field: web.public.GetInstatouchPiiResponse.Status status = 1;
   */
  status = GetInstatouchPiiResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<GetInstatouchPiiResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetInstatouchPiiResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetInstatouchPiiResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetInstatouchPiiResponse {
    return new GetInstatouchPiiResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetInstatouchPiiResponse {
    return new GetInstatouchPiiResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetInstatouchPiiResponse {
    return new GetInstatouchPiiResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetInstatouchPiiResponse | PlainMessage<GetInstatouchPiiResponse> | undefined, b: GetInstatouchPiiResponse | PlainMessage<GetInstatouchPiiResponse> | undefined): boolean {
    return proto3.util.equals(GetInstatouchPiiResponse, a, b);
  }

  static _enums: {
    Status: typeof GetInstatouchPiiResponse.Status,
  };
}

export namespace GetInstatouchPiiResponse {
  /**
   * @generated from enum web.public.GetInstatouchPiiResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetInstatouchPiiResponse.Status)
  proto3.util.setEnumType(GetInstatouchPiiResponse.Status, "web.public.GetInstatouchPiiResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

